import { useState, useEffect, useRef } from 'react';

export function useTypewriter(text: string, speed = 50) {
  const [displayed, setDisplayed] = useState('');
  const indexRef = useRef(0);

  useEffect(() => {
    if (indexRef.current >= text.length) return;

    const timer = setTimeout(() => {
      setDisplayed(prev => prev + text[indexRef.current++]);
    }, speed);

    return () => clearTimeout(timer);
  }, [text, speed, displayed]);

  return displayed;
}
